<template>
    <div class="container-fluid">
        <div class="max-w-[985px] mx-auto">
            <div class="product-dtls-navtab  border-y border-bdr-clr dark:border-bdr-clr-drk">
                <ul id="user-nav-tabs" class=" text-title dark:text-white text-base sm:text-lg lg:text-xl flex leading-none gap-3 sm:gap-6 md:gap-12 lg:gap-24 justify-between sm:justify-start max-w-md sm:max-w-full">
                    <li @click="activeTab = 1" class="py-3 sm:py-5 lg:6 relative before:absolute before:w-full before:h-[1px] before:bg-title before:top-full before:left-0 before:duration-300 dark:before:bg-white before:opacity-0" :class="activeTab === 1 ? 'active' : ''"><router-link to="#" class="duration-300 hover:text-primary">Description</router-link></li>
                    <li @click="activeTab = 2" class="py-3 sm:py-5 lg:6 relative before:absolute before:w-full before:h-[1px] before:bg-title before:top-full before:left-0 before:duration-300 dark:before:bg-white before:opacity-0" :class="activeTab === 2 ? 'active' : ''"><router-link to="#" class="duration-300 hover:text-primary">Shipping &amp; Returns</router-link></li>
                </ul>
            </div>
            <div id="content" class="mt-5 sm:mt-8 lg:mt-12 mx-0 sm:mr-5 md:mr-8 lg:mr-12">
                <div v-if="activeTab === 1">
                    <p v-if="description" class="sm:text-lg">{{ description }}</p>
                    <p v-else class="sm:text-lg text-paragraph dark:text-white-light">
                        Handmade in our Ghazir workshop. Ask us for the full specification of this piece.
                    </p>
                    <ul v-if="specs.length" class="mt-4 sm:mt-6 grid gap-4 sm:gap-5 sm:text-lg leading-none">
                        <li v-for="spec in specs" :key="spec.label">{{ spec.label }} : {{ spec.value }}</li>
                    </ul>
                </div>
                <div v-if="activeTab === 2">
                    <div v-for="(item, index) in shippingAbout" :key="index" class="first:mt-0 mt-4">
                        <h4 class="text-xl sm:text-2xl leading-none font-medium">{{item.title}}</h4>
                        <p class="sm:text-lg mt-3">{{item.desc}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { computed, defineProps, ref } from 'vue';
    import { shippingAbout } from '@/data/data';

    // The tab used to print fixed sample text on every product; it now reads the
    // piece it is actually rendered beside.
    const props = defineProps({
        product: { type: Object, default: null },
    });

    const activeTab = ref(1);

    const description = computed(() => props.product?.description || props.product?.shortDescription || '');

    const specs = computed(() => {
        const product = props.product;

        if (!product) {
            return [];
        }

        const entries = [
            ['SKU', product.sku],
            ['Category', product.categoryName],
            ['Collection', product.subCategoryName],
            ['Dimensions', product.dimensions],
            ['Weight', product.weight],
            ['Made to order', product.isCustomizable ? 'Yes — customisable' : ''],
        ];

        (product.modifiers || []).forEach((modifier) => {
            const options = (modifier.options || []).map((option) => option.label).filter(Boolean);

            if (options.length) {
                entries.push([modifier.name, options.join(', ')]);
            }
        });

        return entries
            .filter(([, value]) => value)
            .map(([label, value]) => ({ label, value }));
    });
</script>
